/**
 * Which mesh parser an upload needs.
 *
 * Lives outside ``MeshPreview`` on purpose: the thumbnail wrapper needs
 * the format for its placeholder badge, and importing it from the
 * viewer would drag three.js + drei into the eager bundle that
 * ``React.lazy`` exists to keep them out of.
 */

export type MeshFormat = "stl" | "obj" | "3mf";

export const MESH_FORMATS: readonly MeshFormat[] = ["stl", "obj", "3mf"];

const KNOWN = new Set<string>(MESH_FORMATS);

export function extensionOf(value: string | null | undefined): string {
  if (!value) return "";
  const base = value.split("?")[0].split("#")[0].split("/").pop() ?? "";
  const dot = base.lastIndexOf(".");
  return dot === -1 ? "" : base.slice(dot + 1).toLowerCase();
}

/**
 * Parser to use for this upload. ``fileName`` wins over the storage URL
 * — rows written before the storage key kept the upload's real
 * extension carry ``source.stl`` for every mesh format, so the original
 * name is the more truthful of the two. Unknown ⇒ ``stl``, which is what
 * those legacy keys overwhelmingly were.
 */
export function meshFormatFrom(
  fileName?: string | null,
  src?: string | null,
): MeshFormat {
  for (const candidate of [extensionOf(fileName), extensionOf(src)]) {
    if (KNOWN.has(candidate)) return candidate as MeshFormat;
  }
  return "stl";
}
